module.exports = {	
	'Connect Wallet' : '지갑 연결',
	'Lossless mining' : '무손실 채굴',
	'Liquidity pledge-free' : '유동성 서약 없음',
	'Reward' : '보상',
	'Million' : '100만',
	'Receive Voucher' : '바우처 받기',
	'Invite Friends' : '친구를 초대',
	'Mining Pool' : '마이닝 풀',
	'Account' : '계정',

	'Pool data' : '내 계정',
	'Valid node' : '지갑 잔액',
	'Participant' : '교환 가능',
	'User Revenue' : '인출 가능',
	'Mining' : '채광',
	'Liquidity mining income' : '유동성 채굴 소득',
	'User Output' : '사용자 출력',
	'Address' : '주소',
	'Help center' : '지원 센터',
	'Hope it helps you' : '도움이 되기를 바랍니다.',
	'How do i need to join？' : '어떻게 가입합니까？',
	'Participating in non-destructive and non-guaranteed liquidity mining requires payment of ETH miner fees to receive the replacement gold coupons, and the ETH wallet address only needs to be claimed once. Automatically open mining permissions after success.' : '매일 생성되는 화폐를 USDT로 환산한 후 출금을 시작할 수 있습니다. USDT 출금은 귀하가 노드에 추가한 지갑 주소로 자동 발송되며, 다른 주소는 지원하지 않습니다. ',
	'How do i withdraw money？' : '어떻게 돈을 인출합니까？',
	'You can convert the currency generated every day into USDT, and then initiate a withdrawal. USDT withdrawals will be automatically sent to the wallet address you added to the node, other addresses are not supported.' : '매일 생성되는 화폐를 USDT로 환산한 후 출금을 시작할 수 있습니다. USDT 출금은 귀하가 노드에 추가한 지갑 주소로 자동 발송되며, 다른 주소는 지원하지 않습니다. ',
    'How to calculate income？':'소득을 계산하는 방법？',
    'When you join successfully, the smart contract starts to calculate your address through the node and start to calculate the revenue.' : '성공적으로 가입하면 스마트 계약은 노드를 통해 주소 계산을 시작하고 수익 계산을 시작합니다. ',
    'What is revenue？':'수익률은 얼마입니까？',
    'The yield below1000USDT≈0.5%~0.6%, ' : 'T1000USDT≈0.5%~0.6% 이하의 수익률,',
    '1000USDT-5000USDT≈1.6%~2.0%, ' : '1000USDT-5000USDT≈1.6%~2.0%,',
    '5000USDT-20000USDT yield≈1.8%~2.2%, ' : '5000USDT-20000USDT 수익률 ≈1.8%~2.2%, ',
    '20000USDT-50000USDT yield≈2.2%~2.6%, ' : '20000USDT-50000USDT 수익률 ≈2.2%~2.6%,',
    '50000USDT-200000USDT yield≈2.6%~3.0%, ' : '50000USDT-200000USDT 수익률 ≈2.6%~3%, ',
    'and above 200000USDT yield Rate≈2.8%~3.5% ' : '200000USDT 이상 수익률≈2.8%~3.5%',
    'What are the extra gains？' : '추가 이득은 무엇입니까？',
    'You can share our page to a friend, if he joins, you can get 10% of his income as a bonus,your sharing link is on the top left corner of the homepage to get.' : '우리 페이지를 친구들과 공유할 수 있습니다. 그가 가입하면 소득의 10%를 보너스로 받을 수 있습니다. 공유 링크는 홈페이지 왼쪽 상단에서 얻을 수 있습니다.',
	'My account' : '내 계정',
	'Total output' : '총 생산량',
	'Wallet balance' : '지갑 잔액',
	'Exchangeable' : '교환 가능',
	'Withdrawable' : '인출 가능',
	'Exchange' : '교환',
	'Withdraw' : '철회하다',
	'Record' : '기록',
	'Redeem all' : '모두 사용',
	'Total balance' : '전체 균형',
	'Confirm' : 'Confirm',
	'Time' : '시간',
	'Quantity' : '수량',
	'Status' : '상태',
	'No Data' : '데이터 없음',
	'Output' : '산출',
	'Fee' : '수수료',
	'Scope' : '범위',
	'Daily acceptance times' : '일 일 접수 횟수：',
	'Your withdrawal will be sent to your USDT wallet address within 24 hours in the future' : '인출은 향후 24시간 이내에 USDT 지갑 주소로 전송됩니다.',
	'Audit report' : '감사 보고서',
	'We have a secure audit report' : '보안 감사 보고서가 있습니다.',
	'Partner' : '파트너',
	'our business partner' : '우리의 비즈니스 파트너',
	'Share friends' : '친구 공유',
	'My share link' : '내 공유 링크',
	'Copy' : '복사',
	"Send your invitation link, friends join the node through your link, and you will get generous token rewards.You can get 10% of the recommended person's income" : "초대 링크를 보내면 친구가 링크를 통해 노드에 가입하면 푸짐한 토큰 보상을 받을 수 있습니다.추천인 소득의 10%를 받을 수 있습니다",
	'There was an issue signing you in.' : '로그인하는 동안 문제가 발생했습니다.',
	'Receive description' : '설명 받기',
	"You need to pay a miner's fee to receive the voucher, please make sure that your wallet has enough ETH as the miner's fee" : "바우처를 받으려면 광부 수수료를 지불해야 합니다. 지갑에 광부 수수료로 충분한 ETH/TRX가 있는지 확인하십시오.",
	"Receive" : "받다",
	"You have successfully joined the node and started mining" : "노드에 성공적으로 가입하고 마이닝을 시작했습니다."
}


// WEBPACK FOOTER //
// ./src/assets/lang/ke.js